import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { seteditedNewEdges } from "../redux/edgesSlice";
import { seteditedNewNodes, setRootId } from "../redux/nodesSlice";
import { useGetHierarchyQuery } from "../redux/organizationApi";

export const useHydrateHierarchy = () => {
  const dispatch = useDispatch();
  const queryState = useGetHierarchyQuery();
  // console.log(queryState);

  useEffect(() => {
    if (queryState.data) {
      dispatch(seteditedNewNodes(queryState.data.nodes));
      dispatch(seteditedNewEdges(queryState.data.edges));
      dispatch(setRootId(queryState.data.rootId));
    }
  }, [dispatch, queryState.data]);

  return queryState;
};
